import { type Ref } from 'react';

import { TokenizedTextArea } from '@/components/Form';
import { type TokenizedTextAreaProps } from '@/components/Form/inputs/TokenizedTextArea/TokenizedTextArea';

import { isDomainValid } from './validator';

type Props = Omit<TokenizedTextAreaProps, 'onChange' | 'getChipClassName'> & {
  ref?: Ref<HTMLInputElement>;
  onChange?: (values: string[]) => void;
};

const AudienceCSVInput = ({ ref, disabled, tokenSeparators, onChange, ...props }: Props) => {
  const handleChange = (newValues: string[]) => {
    const sanitizedValues = newValues.map((value) => value.trim());

    if (onChange) {
      onChange(sanitizedValues);
    }
  };

  return (
    <TokenizedTextArea
      ref={ref}
      disabled={disabled}
      tokenSeparators={tokenSeparators}
      onChange={handleChange}
      {...props}
      getChipClassName={(value) =>
        isDomainValid(value)
          ? 'bg-green-300 text-gray-900 focus-visible:bg-green-400 focus-visible:outline-green-500'
          : 'bg-red-200 text-gray-900 focus-visible:bg-red-300 focus-visible:outline-red-500'
      }
    />
  );
};

export default AudienceCSVInput;
